module.exports = "<ngb-pagination class=\"col-center\" [collectionSize]=\"paginationObject.collectionSize\" [(page)]=\"paginationObject.page\"\r\n  [maxSize]=\"paginationObject.maxSize\" [rotate]=\"true\" [pageSize]=\"paginationObject.pageSize\"\r\n  (pageChange)=\"onPageChange($event)\">\r\n</ngb-pagination>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/+admin/modules/display/cb-pagination/cb-pagination.component.html
// module id = 1153
// module chunks = 0